export default "__VITE_ASSET__CaAjedxT__"